<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_40002921_5255)">
      <circle
        cx="12"
        cy="12.833"
        r="7.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M6.16667 17.833L4.5 19.4997M17.8333 17.833L19.5 19.4997"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.8337 4.97475L18.3299 4.72663C19.0343 4.37443 19.2989 4.41474 19.8589 4.97475C20.4189 5.53475 20.4592 5.79937 20.107 6.50375L19.8589 7M6.16699 4.97475L5.67075 4.72663C4.96636 4.37443 4.70175 4.41474 4.14174 4.97475C3.58174 5.53475 3.54143 5.79937 3.89362 6.50375L4.14174 7"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M12 9.91602V13.2493L13.6667 14.916"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 4.91602V3.66602"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.333 3.66602H13.6663"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_40002921_5255">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(2 2)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
